<mat-expansion-panel [expanded]="isExpanded()" class="order" #panel>
  <mat-expansion-panel-header>
    <div class="order__header">
      <div class="order__header__top">
        <span class="order__header__code" (click)="redirectOrderGroupDetail(order().orders[0].orderId)">
          @if (order().orders[0].orderType == 'TD') {
          <mat-icon fontSet="material-icons-outlined">sell</mat-icon>
          } @else {
          <mat-icon fontSet="material-icons-outlined">shopping_bag</mat-icon>
          }
          {{ order().orderGroup }}
        </span>
        <div class="order__header__info">
          <span class="order__header__tag">
            <mat-icon>calendar_today</mat-icon>
            {{ order().creationDate | date : "dd/MM/yy" }}
          </span>
          <span class="order__header__tag">
            S/ {{ order().groupTotal | number : "1.2-2" }}
          </span>
          <button
            class="order__header__tag"
            (click)="openOrderProductDrawer($event)"
          >
            <mat-icon>shopping_cart</mat-icon>
            Ver {{ order().productsCount }}
            {{ order().productsCount === 1 ? "producto" : "productos" }}
          </button>
        </div>
      </div>
      <div class="order__header__bottom" *ngIf="!panel.expanded">
        <div class="order__header__bottom__container">
          @for (subOrder of order().orders; track subOrder.orderId){
          <div
            class="order__sub-order order__sub-order--compact"
            (click)="redirectOrderGroupDetail(subOrder.orderId)"
          >
            <div class="order__sub-order__header">
              <span class="order__sub-order__code">
                {{ subOrder.orderId }}
                @if (subOrder.deliveryTypeId === 1) {
                <span class="order__sub-order__type">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="9"
                    viewBox="0 0 11 9"
                    fill="none"
                  >
                    <path
                      d="M0.120781 0.139491C0.201338 0.0589561 0.297036 0.0185547 0.407225 0.0185547H6.92586C7.03618 0.0185547 7.13172 0.0589561 7.2123 0.139491C7.2929 0.220138 7.33324 0.315679 7.33324 0.426003V1.64826H8.35181C8.46642 1.64826 8.59061 1.67584 8.72428 1.731C8.85797 1.78625 8.9651 1.85403 9.0457 1.93468L10.3062 3.19513C10.3613 3.25029 10.409 3.3139 10.4494 3.3861C10.4897 3.45812 10.5194 3.523 10.5385 3.58019C10.5576 3.63754 10.5715 3.71595 10.5799 3.81578C10.5883 3.91555 10.5937 3.98875 10.5958 4.03546C10.5978 4.08211 10.5978 4.16278 10.5958 4.27738C10.5937 4.39203 10.5926 4.46623 10.5926 4.50024V6.53725C10.7029 6.53725 10.7984 6.57754 10.879 6.65828C10.9597 6.73875 11 6.83433 11 6.94468C11 7.00825 10.9916 7.06454 10.9746 7.11328C10.9576 7.16211 10.929 7.20133 10.8886 7.2311C10.8483 7.26087 10.8132 7.28519 10.7836 7.30434C10.7538 7.32341 10.7039 7.33609 10.6339 7.34249C10.5639 7.34889 10.5162 7.35317 10.4907 7.35531C10.4652 7.3573 10.4112 7.3573 10.3284 7.35531C10.2456 7.35317 10.1979 7.3521 10.1851 7.3521H9.77775C9.77775 7.80183 9.61857 8.18593 9.30035 8.50426C8.98203 8.82252 8.59799 8.98169 8.14811 8.98169C7.69828 8.98169 7.3142 8.82252 6.99593 8.50426C6.67761 8.18595 6.51854 7.80183 6.51854 7.3521H4.07401C4.07401 7.80183 3.91484 8.18593 3.5966 8.50426C3.2784 8.82252 2.8943 8.98169 2.44442 8.98169C1.99445 8.98169 1.61059 8.82252 1.29224 8.50426C0.973915 8.18595 0.814829 7.80183 0.814829 7.3521C0.802165 7.3521 0.754383 7.35317 0.671685 7.35531C0.588898 7.3573 0.534784 7.3573 0.509321 7.35531C0.483814 7.35317 0.435987 7.34889 0.366021 7.34249C0.296032 7.33609 0.246222 7.32343 0.216456 7.30434C0.18669 7.28526 0.151773 7.26087 0.111461 7.2311C0.0711039 7.20133 0.0424084 7.16211 0.0254853 7.11328C0.00831695 7.06452 2.00383e-07 7.00822 2.00383e-07 6.94468V0.426069C-8.8986e-05 0.315724 0.0402008 0.220294 0.120781 0.139491ZM7.57531 7.92501C7.73649 8.08622 7.92753 8.16702 8.1482 8.16702C8.36889 8.16702 8.55988 8.08631 8.72115 7.92501C8.88243 7.76385 8.96303 7.5728 8.96303 7.35215C8.96303 7.13148 8.88234 6.94033 8.72115 6.7791C8.55991 6.61794 8.36891 6.53723 8.1482 6.53723C7.92753 6.53723 7.73652 6.61788 7.57531 6.7791C7.41397 6.94033 7.33333 7.13148 7.33333 7.35215C7.33333 7.5728 7.41397 7.76385 7.57531 7.92501ZM7.33333 4.09274H9.77783V3.90184C9.77783 3.84666 9.75877 3.79997 9.72058 3.76175L8.47924 2.52046C8.44107 2.48224 8.39431 2.4632 8.33915 2.4632H7.33333V4.09274ZM1.87155 7.92501C2.03276 8.08622 2.22377 8.16702 2.44442 8.16702C2.66516 8.16702 2.85624 8.08631 3.01744 7.92501C3.17867 7.76385 3.25934 7.5728 3.25934 7.35215C3.25934 7.13148 3.17869 6.94033 3.01744 6.7791C2.85624 6.61794 2.66516 6.53723 2.44442 6.53723C2.22377 6.53723 2.03276 6.61788 1.87155 6.7791C1.71033 6.94042 1.62959 7.13148 1.62959 7.35215C1.62959 7.5728 1.71017 7.76385 1.87155 7.92501Z"
                      fill="#457BE0"
                    />
                  </svg>
                  {{ subOrder.deliveryType }}
                </span>
                } @else {
                <span
                  class="order__sub-order__type order__sub-order__type--green"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M1.15658 4.8894L1.73408 2.4859C1.85508 1.9909 2.28408 1.6499 2.78458 1.6499H10.4241C10.9191 1.6499 11.3536 1.9964 11.4691 2.4859L12.0466 4.8894C12.1786 5.4504 12.0576 6.0224 11.7056 6.4734C11.6616 6.5339 11.6011 6.5779 11.5516 6.6329V10.4499C11.5516 11.0549 11.0566 11.5499 10.4516 11.5499H2.75158C2.14658 11.5499 1.65158 11.0549 1.65158 10.4499V6.6329C1.60208 6.5834 1.54158 6.5339 1.49758 6.4789C1.14558 6.0279 1.01908 5.4504 1.15658 4.8894ZM2.80108 2.7444L2.22358 5.1479C2.16858 5.3789 2.21808 5.6099 2.36108 5.7914C2.43808 5.8904 2.60308 6.0499 2.87808 6.0499C3.21358 6.0499 3.50508 5.7804 3.54358 5.4229L3.86258 2.7499L2.80108 2.7444ZM6.05158 2.7499H4.97358L4.67658 5.2359C4.64908 5.4504 4.71508 5.6649 4.85808 5.8244C4.97908 5.9674 5.15508 6.0499 5.38058 6.0499C5.74908 6.0499 6.05158 5.7254 6.05158 5.3294V2.7499ZM8.53208 5.2359L8.22958 2.7499H7.15158V5.3294C7.15158 5.7254 7.45408 6.0499 7.86108 6.0499C8.04808 6.0499 8.21858 5.9674 8.35058 5.8244C8.48808 5.6649 8.55408 5.4504 8.53208 5.2359ZM10.9796 5.1479L10.4241 2.7499H9.34058L9.65958 5.4229C9.70358 5.7804 9.98958 6.0499 10.3251 6.0499C10.5946 6.0499 10.7651 5.8904 10.8366 5.7914C10.9851 5.6154 11.0346 5.3789 10.9796 5.1479ZM10.4516 10.4499V7.1334C10.4076 7.1389 10.3691 7.1499 10.3251 7.1499C9.84658 7.1499 9.41208 6.9519 9.09308 6.6274C8.76308 6.9574 8.32308 7.1499 7.82258 7.1499C7.34408 7.1499 6.91508 6.9519 6.59608 6.6384C6.27158 6.9519 5.83158 7.1499 5.33658 7.1499C4.87458 7.1499 4.43458 6.9574 4.10458 6.6274C3.78558 6.9519 3.35108 7.1499 2.87258 7.1499C2.82858 7.1499 2.79008 7.1389 2.74608 7.1334V10.4499H10.4516Z"
                      fill="#0A806A"
                    />
                  </svg>
                  {{ subOrder.deliveryType }}
                </span>
                }
              </span>
              <div class="order__sub-order__right">
                <div class="order__sub-order__external">
                  <app-order-integration-services
                    [loaded]="orderRexAriaService.loaded()"
                    [serviceInfo]="
                      orderRexAriaService.dataRexAria().get(subOrder.orderId)
                    "
                    (redirectSection)="
                      redirectOrderGroupDetail(
                        subOrder.orderId,
                        undefined,
                        $event
                      )
                    "
                  ></app-order-integration-services>
                </div>
                <span class="order__sub-order__status">
                  {{ subOrder.statusOrderDescription }}
                </span>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </mat-expansion-panel-header>

  <div class="order__body">
    <div class="order__body__container">
      @for (subOrder of order().orders; track subOrder.orderId){
      <div
        class="order__sub-order"
        (click)="redirectOrderGroupDetail(subOrder.orderId)"
      >
        <div class="order__sub-order__header">
          <span class="order__sub-order__code">
            {{ subOrder.orderId }}
            @if (subOrder.deliveryTypeId === 1) {
            <span class="order__sub-order__type">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="9"
                viewBox="0 0 11 9"
                fill="none"
              >
                <path
                  d="M0.120781 0.139491C0.201338 0.0589561 0.297036 0.0185547 0.407225 0.0185547H6.92586C7.03618 0.0185547 7.13172 0.0589561 7.2123 0.139491C7.2929 0.220138 7.33324 0.315679 7.33324 0.426003V1.64826H8.35181C8.46642 1.64826 8.59061 1.67584 8.72428 1.731C8.85797 1.78625 8.9651 1.85403 9.0457 1.93468L10.3062 3.19513C10.3613 3.25029 10.409 3.3139 10.4494 3.3861C10.4897 3.45812 10.5194 3.523 10.5385 3.58019C10.5576 3.63754 10.5715 3.71595 10.5799 3.81578C10.5883 3.91555 10.5937 3.98875 10.5958 4.03546C10.5978 4.08211 10.5978 4.16278 10.5958 4.27738C10.5937 4.39203 10.5926 4.46623 10.5926 4.50024V6.53725C10.7029 6.53725 10.7984 6.57754 10.879 6.65828C10.9597 6.73875 11 6.83433 11 6.94468C11 7.00825 10.9916 7.06454 10.9746 7.11328C10.9576 7.16211 10.929 7.20133 10.8886 7.2311C10.8483 7.26087 10.8132 7.28519 10.7836 7.30434C10.7538 7.32341 10.7039 7.33609 10.6339 7.34249C10.5639 7.34889 10.5162 7.35317 10.4907 7.35531C10.4652 7.3573 10.4112 7.3573 10.3284 7.35531C10.2456 7.35317 10.1979 7.3521 10.1851 7.3521H9.77775C9.77775 7.80183 9.61857 8.18593 9.30035 8.50426C8.98203 8.82252 8.59799 8.98169 8.14811 8.98169C7.69828 8.98169 7.3142 8.82252 6.99593 8.50426C6.67761 8.18595 6.51854 7.80183 6.51854 7.3521H4.07401C4.07401 7.80183 3.91484 8.18593 3.5966 8.50426C3.2784 8.82252 2.8943 8.98169 2.44442 8.98169C1.99445 8.98169 1.61059 8.82252 1.29224 8.50426C0.973915 8.18595 0.814829 7.80183 0.814829 7.3521C0.802165 7.3521 0.754383 7.35317 0.671685 7.35531C0.588898 7.3573 0.534784 7.3573 0.509321 7.35531C0.483814 7.35317 0.435987 7.34889 0.366021 7.34249C0.296032 7.33609 0.246222 7.32343 0.216456 7.30434C0.18669 7.28526 0.151773 7.26087 0.111461 7.2311C0.0711039 7.20133 0.0424084 7.16211 0.0254853 7.11328C0.00831695 7.06452 2.00383e-07 7.00822 2.00383e-07 6.94468V0.426069C-8.8986e-05 0.315724 0.0402008 0.220294 0.120781 0.139491ZM7.57531 7.92501C7.73649 8.08622 7.92753 8.16702 8.1482 8.16702C8.36889 8.16702 8.55988 8.08631 8.72115 7.92501C8.88243 7.76385 8.96303 7.5728 8.96303 7.35215C8.96303 7.13148 8.88234 6.94033 8.72115 6.7791C8.55991 6.61794 8.36891 6.53723 8.1482 6.53723C7.92753 6.53723 7.73652 6.61788 7.57531 6.7791C7.41397 6.94033 7.33333 7.13148 7.33333 7.35215C7.33333 7.5728 7.41397 7.76385 7.57531 7.92501ZM7.33333 4.09274H9.77783V3.90184C9.77783 3.84666 9.75877 3.79997 9.72058 3.76175L8.47924 2.52046C8.44107 2.48224 8.39431 2.4632 8.33915 2.4632H7.33333V4.09274ZM1.87155 7.92501C2.03276 8.08622 2.22377 8.16702 2.44442 8.16702C2.66516 8.16702 2.85624 8.08631 3.01744 7.92501C3.17867 7.76385 3.25934 7.5728 3.25934 7.35215C3.25934 7.13148 3.17869 6.94033 3.01744 6.7791C2.85624 6.61794 2.66516 6.53723 2.44442 6.53723C2.22377 6.53723 2.03276 6.61788 1.87155 6.7791C1.71033 6.94042 1.62959 7.13148 1.62959 7.35215C1.62959 7.5728 1.71017 7.76385 1.87155 7.92501Z"
                  fill="#457BE0"
                />
              </svg>
              {{ subOrder.deliveryType }}
            </span>
            } @else {
            <span class="order__sub-order__type order__sub-order__type--green">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M1.15658 4.8894L1.73408 2.4859C1.85508 1.9909 2.28408 1.6499 2.78458 1.6499H10.4241C10.9191 1.6499 11.3536 1.9964 11.4691 2.4859L12.0466 4.8894C12.1786 5.4504 12.0576 6.0224 11.7056 6.4734C11.6616 6.5339 11.6011 6.5779 11.5516 6.6329V10.4499C11.5516 11.0549 11.0566 11.5499 10.4516 11.5499H2.75158C2.14658 11.5499 1.65158 11.0549 1.65158 10.4499V6.6329C1.60208 6.5834 1.54158 6.5339 1.49758 6.4789C1.14558 6.0279 1.01908 5.4504 1.15658 4.8894ZM2.80108 2.7444L2.22358 5.1479C2.16858 5.3789 2.21808 5.6099 2.36108 5.7914C2.43808 5.8904 2.60308 6.0499 2.87808 6.0499C3.21358 6.0499 3.50508 5.7804 3.54358 5.4229L3.86258 2.7499L2.80108 2.7444ZM6.05158 2.7499H4.97358L4.67658 5.2359C4.64908 5.4504 4.71508 5.6649 4.85808 5.8244C4.97908 5.9674 5.15508 6.0499 5.38058 6.0499C5.74908 6.0499 6.05158 5.7254 6.05158 5.3294V2.7499ZM8.53208 5.2359L8.22958 2.7499H7.15158V5.3294C7.15158 5.7254 7.45408 6.0499 7.86108 6.0499C8.04808 6.0499 8.21858 5.9674 8.35058 5.8244C8.48808 5.6649 8.55408 5.4504 8.53208 5.2359ZM10.9796 5.1479L10.4241 2.7499H9.34058L9.65958 5.4229C9.70358 5.7804 9.98958 6.0499 10.3251 6.0499C10.5946 6.0499 10.7651 5.8904 10.8366 5.7914C10.9851 5.6154 11.0346 5.3789 10.9796 5.1479ZM10.4516 10.4499V7.1334C10.4076 7.1389 10.3691 7.1499 10.3251 7.1499C9.84658 7.1499 9.41208 6.9519 9.09308 6.6274C8.76308 6.9574 8.32308 7.1499 7.82258 7.1499C7.34408 7.1499 6.91508 6.9519 6.59608 6.6384C6.27158 6.9519 5.83158 7.1499 5.33658 7.1499C4.87458 7.1499 4.43458 6.9574 4.10458 6.6274C3.78558 6.9519 3.35108 7.1499 2.87258 7.1499C2.82858 7.1499 2.79008 7.1389 2.74608 7.1334V10.4499H10.4516Z"
                  fill="#0A806A"
                />
              </svg>
              {{ subOrder.deliveryType }}
            </span>
            }
          </span>
          <div class="order__sub-order__right">
            <div class="order__sub-order__external">
              <app-order-integration-services
                [loaded]="orderRexAriaService.loaded()"
                [serviceInfo]="
                  orderRexAriaService.dataRexAria().get(subOrder.orderId)
                "
                (redirectSection)="
                  redirectOrderGroupDetail(subOrder.orderId, undefined, $event)
                "
              ></app-order-integration-services>
            </div>
            <span class="order__sub-order__status">
              {{ subOrder.statusOrderDescription }}
            </span>
          </div>
        </div>
        <div class="order__sub-order__info">
          <div class="order__sub-order__details">
            <div class="order__sub-order__details__item">
              <span class="order__sub-order__details__label">Vendido por</span>
              <div
                class="order__sub-order__details__value order__sub-order__details__value--seller"
                #tooltip="matTooltip"
                [matTooltip]="subOrder.seller"
                matTooltipPosition="below"
              >
                <span
                  class="order__sub-order__details__dot"
                  [ngClass]="
                    'order__sub-order__details__dot--' +
                    formatSeller(subOrder.seller)
                  "
                ></span>
                <span
                  class="seller-name"
                  [ngClass]="'seller-name--' + formatSeller(subOrder.seller)"
                  >{{ subOrder.seller }}</span
                >
              </div>
            </div>
            <div class="order__sub-order__details__item">
              <span class="order__sub-order__details__label">Productos</span>
              <div
                class="order__sub-order__details__value order__sub-order__details__value--product"
              >
                <mat-icon fontSet="material-icons-outlined"
                  >shopping_cart</mat-icon
                >
                <span>{{ subOrder.productsCount }}</span>
              </div>
            </div>

            <div class="order__sub-order__details__item">
              <span class="order__sub-order__details__label">F. elegida</span>
              <div class="order__sub-order__details__value order__sub-order__details__value--date">
                <mat-icon
                  [class]="utilService.getClassIconTimer(getShippingEstimate(subOrder), getDeliveryDate(subOrder), subOrder.statusOrder)">timer
                </mat-icon>
                <span>{{ getShippingEstimate(subOrder) | date : "dd/MM/yy"}}</span>
              </div>
            </div>

            <div class="order__sub-order__details__item">
              <span class="order__sub-order__details__label">Facturado</span>
              <app-order-invoicing-status
                #invoicingStatus
                [tenantId]="tenantId()"
                [orderId]="subOrder.orderId"
              />
            </div>
          </div>
          <div class="order__sub-order__actions">
            <button
              class="order__sub-order__actions__button action-button"
              [disabled]="!invoicingStatus.state.isInvoiced()"
              (click)="openVoucherDialog($event, subOrder)"
            >
              <mat-icon fontSet="material-icons-outlined"
                >receipt_long</mat-icon
              >
              Comprobante
            </button>
            <button
              class="order__sub-order__actions__button action-button"
              [disabled]="shouldDisable(subOrder, 'DELIVERED', 'CANCELLED')"
              (click)="openOrderRescheduleDrawer($event, subOrder)"
            >
              <mat-icon fontSet="material-icons-outlined">timer</mat-icon>
              Reprogramar
            </button>
            <button
              class="order__sub-order__actions__button action-button"
              (click)="openCreateTicketDrawer($event, subOrder)"
            >
              <mat-icon fontSet="material-icons-outlined"
                >sim_card_alert</mat-icon
              >
              Crear ticket
            </button>
            <button
              class="order__sub-order__actions__button action-button"
              [disabled]="shouldDisable(subOrder, 'DELIVERED', 'CANCELLED')"
              (click)="openOrderCancelDrawer($event, subOrder)"
            >
              <mat-icon fontSet="material-icons-outlined">cancel</mat-icon>
              Anular
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</mat-expansion-panel>
